module.exports = __webpack_public_path__ + "img/chahua.b4d4694.png";